module.exports = __webpack_public_path__ + "img/tendertrace_logo-white-pink-bars.10b92fc2.png";